<template>

  <div class="right-item">
    <h1>{{title}}</h1>
    <p v-if="context">{{context}}</p>
  </div>
</template>

<script>
export default {
  props: ["context", "title"],
  data() {
    return {};
  },
  methods: {},
};
</script>
 
<style lang="less" scoped>
.right-item {
  box-sizing: border-box;
  padding: 31px 41px;
  box-shadow: 0px 10px 20px 0px rgba(69, 158, 255, 0.1);
  > h1 {
    color: rgba(16, 16, 16, 1);
    font-size: 20px;
    font-weight: bold;
  }
  > p {
    display: inline-block;
    margin-top: 27px;
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    line-height: 22px;
  }
}
</style>